<template>
	<div class="Quota">
		<div class="content-menu">
			<div class="menu-item" :class="[current===index?'current':'']" v-for="(item,index) in menuList" :key="index"
				@click="handClick(index)">
				{{item.title}}
			</div>
		</div>
		<component :is="menuList[current].component" :auth="menuList[current].auth"></component>
	</div>
</template>

<script>
	import quotaMonth from './components/quotaMonth.vue';
	import quotaIms from './components/quotaIms.vue';
	import quotaSummary from './components/quotaSummary.vue';

	export default {
		data() {
			return {
				current: 0,
				menuList: [],
			}
		},
		computed: {
			menusData() {
				return this.$store.state.MenusData.CusWebMenus;
			}
		},
		created() {
			this.setMenuList();
		},
		methods: {
			setMenuList() {
				let NodeInfo = this.menusData.filter(item => item.NodeID === '77')[0].Nodes.filter(item => item.NodeID ===
					'79')[0].Nodes.filter(item => item.NodeID === '130')[0].Nodes;
				this.menuList = NodeInfo.map(item => {
					item.title = item.NodeName;
					item.auth = item.Buttons.map(item1 => item1.NodeName);
					if (item.NodeID === '131') {
						item.component = quotaMonth;
					}
					if (item.NodeID === '132') {
						item.component = quotaIms;
					}
					if (item.NodeID === '133') {
						item.component = quotaSummary;
					}
					return item;
				})
			},
			handClick(index) {
				this.current = index;
			}
		}
	}
</script>
<style scoped lang="less">
	.Quota {
		width: 100%;
		height: 100%;
		position: relative;

		.content-menu {
			display: flex;
			align-items: center;
			user-select: none;
			cursor: pointer;

			.menu-item {
				flex: 1;
				height: 40px;
				line-height: 40px;
				text-align: center;
				box-sizing: border-box;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #16181A;
				border: 1px solid #E6E8EB;
			}

			.current {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
				background: #00266D;
				border: 1px solid #00266D;
			}

			.menu-item:nth-child(2) {
				border-left: 0px;
				border-right: 0px;
			}
		}
	}
</style>
